import { combineReducers } from "redux";

import callsReducer from "../features/calls/callsSlice.mjs";

import searchReducer from "./search/reducers";
import inboxReducer from "./inbox/reducers";
import caseReducer from "./case/reducers";
import todosReducer from "./todos/reducers";
import injuriesReducer from "./injuries/reducer";
import menuReducer from "./menu/reducers";
import modalReducer from "./modal/reducers";
import clientProviderReducer from "./client-providers/clientProviderSlice";
import clientReducer from "./client/clientSlice";
import caseDataReducer from "./caseData/caseDataSlice";
import headerDataReducer from "./header/headerDataSlice";
import generalReducer from "./general/reducers";
import accidentReducer from "./accident/accidentSlice";
import settingsReducer from "./settings/settingsSlice";
import noteReducer from "./notes/reducers";
import notesReducer from "./notes/notesSlice";
import insuranceReducer from "./insurance/insuranceSlice";
import searchSliceReducer from "./search/searchSlice";
import directorySliceReducer from "./Directory/directorySlice";
import litigationSliceReducer from "./litigation-event/litigationEventSlice";
import solTemplatesSliceReducer from "./sol-templates/solTemplatesSlice";
import dynamicWidthReducer from "./header_width/reducer";
import selectedStateReducer from "./selectedState/reducers";
import selectedSpecialityReducer from "./selectedSpeciality/reducers";
import checkListReducer from "./checklist/reducer";
import blurEffectReducer from "./header_blur/reducer";
import commonLoadingEffectReducer from "./common/Loader/reducer";
import setHeaderNamerReducer from "./header_name/reducer";
import headerChecklistOpen from "./header_checklist/reducer";
import timeCodeSlice from "./time-code/timeCodeSlice";
import statuteSlice from "./statue-data/statuteSlice";
import judgeSlice from "./judge-table/judgeSlice";
import processServerSlice from "./process-server/processServerSlice";
import courtsSlice from "./courts-table/courtsSlice";
import expertsSlice from "./experts-table/expertsSlice";
import insuranceAdjustersSlice from "./insuranceAdjuster/insuranceAdjusterSlice";
import insuranceCompanies from "./insuranceCompany/insuranceCompanySlice";
import disabilityAgencySlice from "./disabilityAgency/disabilityAgencySlice";
import attorneyDirectoriesSlice from "./attorny-table/attornySlice";
import departmentSlice from "./department-table/departmentSlice";
import caseLoan from "./case-loan/caseLoan";
import lawFirmSlice from "./law-firm/lawFirmSlice";
import reportingAgenciesSlice from "./reportingAgencies/reportingAgenciesAdjusterSlice";
import pagesSlice from "./pages/pagesSlice";
import jurisdictionSlice from "./jurisdiction-table/jurisdictionSlice";
import districtSlice from "./district-table/districtSlice";
import statesSlice from "./states/statesSlice";
import divisionSlice from "./divisions/divisonSlice";
import circuitSlice from "./circuits/circuitSlice";
import courtFormSlice from "./courtForms-table/courtFormsSlice";
import calculatedDateSlice from "./calculated-dates-table/calculatedDatesSlice";
import getPageIdReducer from "./getPageId/reducer";
import dependantDateTypeSlice from "./dependant-date-type-table/dependantDateTypeSlice";
import expertCategorySlice from "./expertCategories/expertCategoriesSlice";
import clickKeysSlice from "./clickKeys/clickKeysSlice";
import statusesSlice from "./status-table/statusesSlice";
import checklistsSlice from "./checklists-table/checklistsSlice";
import panelChecklistsSlice from "./panelChecklists-table/panelChecklistsSlice";
import workunitsSlice from "./workunit-table/workunitSlice";
import actsSlice from "./act-table/actsSlice";
import LoggedInInfoDataReducer from "./loggedInfo/reducer";
import jurisdictionTypeReducer from "./jurisdictionType/reducers";
import seletedLitigationEventReducer from "./litigationEventSelect/reducers";
import clientStatusSlice from "./clientStatus/clientStatusSlice";
import ChatReducer from "./new-chat-store/chatSlice";
import clientCommunicationReducer from "./client-communication/clientCommunicationSlice";
import checklistWebSocketReducer from "./checklist-websocket/checklistWebSocketSlice";
import automationEventSlice from "./automation-event/automationEventSlice";
import automationRuleSlice from "./automation-rule/automationRuleSlice";
import ruleActionSlice from "./rule-action/ruleActionSlice";
import ruleDependencySlice from "./rule-dependency/ruleDependencySlice";
import ruleFieldSlice from "./rule-field/ruleFieldSlice";
import firmLogoReducer from "./brandingLogos/firmLogoSlice";
import criticalNotesReducer from "./critical-notes/reducer";
import authPermissionsReducer from "./authPermissions/authPermissionsSlice";

// Combining both reducers into a single root reducer
const appReducer = combineReducers({
  search: searchReducer,
  inbox: inboxReducer,
  case: caseReducer,
  todos: todosReducer,
  injuries: injuriesReducer,
  menu: menuReducer,
  modal: modalReducer,
  clientProvider: clientProviderReducer,
  client: clientReducer,
  caseData: caseDataReducer,
  headerData: headerDataReducer,
  general: generalReducer,
  accident: accidentReducer,
  settings: settingsReducer,
  note: noteReducer,
  notes: notesReducer,
  insurances: insuranceReducer,
  searchS: searchSliceReducer,
  dynamicWidth: dynamicWidthReducer,
  blurEffect: blurEffectReducer,
  loadEffect: commonLoadingEffectReducer,
  checkLists: checkListReducer,
  directory: directorySliceReducer,
  selectedState: selectedStateReducer,
  litigationEvent: litigationSliceReducer,
  solTemplates: solTemplatesSliceReducer,
  selectedSpeciality: selectedSpecialityReducer,
  jurisdictionType: jurisdictionTypeReducer,
  selectedLitigationEvent: seletedLitigationEventReducer,

  timeCodes: timeCodeSlice,

  statutes: statuteSlice,
  judges: judgeSlice,
  departments: departmentSlice,
  caseLoan: caseLoan,
  lawFirm: lawFirmSlice,
  processServers: processServerSlice,
  courts: courtsSlice,
  experts: expertsSlice,
  reportingAgencies: reportingAgenciesSlice,
  insuranceAdjusters: insuranceAdjustersSlice,
  insuranceCompanies: insuranceCompanies,
  disabilityAgencies: disabilityAgencySlice,
  attorneyDirectories: attorneyDirectoriesSlice,
  jurisdictions: jurisdictionSlice,
  districts: districtSlice,
  states: statesSlice,
  divisions: divisionSlice,
  circuits: circuitSlice,
  courtForms: courtFormSlice,
  calculatedDates: calculatedDateSlice,
  dependantDateTypes: dependantDateTypeSlice,
  expertCategories: expertCategorySlice,
  clickKeys: clickKeysSlice,
  statuses: statusesSlice,
  checklistsDirectory: checklistsSlice,
  panelChecklists: panelChecklistsSlice,
  workunits: workunitsSlice,
  acts: actsSlice,
  automationEvents: automationEventSlice,
  automationRules: automationRuleSlice,
  ruleActions: ruleActionSlice,
  ruleDependencies: ruleDependencySlice,
  ruleFields: ruleFieldSlice,
  clientStatus: clientStatusSlice,

  header_name: setHeaderNamerReducer,
  open: headerChecklistOpen,
  allPages: pagesSlice,
  page_id_click_record: getPageIdReducer,
  loggedInfo: LoggedInInfoDataReducer,
  chat2: ChatReducer,
  clientCommunication: clientCommunicationReducer,
  checklistWebSocket: checklistWebSocketReducer,
  firmLogo: firmLogoReducer,
  criticalNotes: criticalNotesReducer,
  authPermissions: authPermissionsReducer,
  calls: callsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_CLIENT_STORE") {
    // Case creation resets page data; the authenticated call runtime survives it.
    // Auth termination explicitly clears calls through the global provider.
    state = state?.calls ? { calls: state.calls } : undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
